import type { GeoCountry, Location, ShipFrom } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";
import {
  EMPTY_LOCATION,
  type LocationDraft,
  type LocationErrors,
  type LocationField,
} from "../../../../core/primitives/location-form";
import type { GeoRegionList } from "../../../../core/repositories/countries-repository";

export class LocationsSectionState {
  readonly locations = new RxList<Location>();
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly shipFrom = new Rx<ShipFrom | null>(null);
  readonly countries = new RxList<GeoCountry>();
  readonly countriesStatus = new Rx<LoadStatus>(idleLoad);

  readonly adding = new Rx(false);
  readonly addDraft = new Rx<LocationDraft>(EMPTY_LOCATION);
  readonly addRegions = new Rx<GeoRegionList>([]);
  readonly addErrors = new Rx<LocationErrors>({});
  readonly addForm = new Rx<FormStatus>(idleForm);

  readonly editingId = new Rx<string | null>(null);
  readonly editDraft = new Rx<LocationDraft>(EMPTY_LOCATION);
  readonly editRegions = new Rx<GeoRegionList>([]);
  readonly editErrors = new Rx<LocationErrors>({});
  readonly editForm = new Rx<FormStatus>(idleForm);

  readonly shipFromForm = new Rx<FormStatus>(idleForm);
  /** The branch whose card reader is being set up, and the last such failure, by branch. */
  readonly terminalBusyId = new Rx<string | null>(null);
  readonly terminalError = new Rx<{ locationId: string; message: string } | null>(null);
}

export abstract class LocationsSectionActions {
  abstract startAdd(): void;
  abstract cancelAdd(): void;
  abstract setAddField(field: LocationField, value: string): void;
  abstract add(): Promise<void>;
  abstract startEdit(locationId: string): void;
  abstract cancelEdit(): void;
  abstract setEditField(field: LocationField, value: string): void;
  abstract saveEdit(): Promise<void>;
  abstract setShipFrom(locationId: string | null): Promise<void>;
  abstract enableTerminal(locationId: string): Promise<void>;
}
